import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material';

@Injectable({
  providedIn: 'root'
})
export class SnackBarService {

  constructor(
    private readonly snackBar: MatSnackBar
  ) { }

  /**
   * @function showToast: Displays a toast message
   * @param message: message to show on toast
   * @param action: action to execute on button click
   * @param duration: display duration, default to 5
   */
  showToast(message: string, action?: any, duration: any = 5) {
    this.snackBar.open(message, action, {
      duration: duration * 1000
    });
  }
}
